import React from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  alpha,
  useTheme,
} from '@mui/material';
import BrandLogo from './BrandLogo';

const Header = ({
  title,
  actions,
  showTitle = true,
  onLogoClick,
  logoSize = 28,
  showLogo = true,
  toolbarSx,
  logoContainerSx,
}) => {
  const theme = useTheme();
  const purple = theme.palette.primary.main;

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: alpha('#0a0c12', 0.52),
        backgroundImage: `linear-gradient(180deg, ${alpha(purple, 0.06)} 0%, ${alpha(theme.palette.secondary.main, 0.03)} 100%)`,
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        borderBottom: `1px solid ${alpha(purple, 0.2)}`,
        boxShadow: 'none',
      }}
    >
      <Toolbar
        sx={{
          minHeight: { xs: 64, sm: 72 },
          px: { xs: 1.5, sm: 2.5 },
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          ...(toolbarSx || {}),
        }}
      >
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          {showLogo ? (
            <Box sx={{ minWidth: 0, ...(logoContainerSx || {}) }}>
              <BrandLogo size={logoSize} showText={showTitle} text={title} onClick={onLogoClick} />
            </Box>
          ) : (
            <Box />
          )}
        </Box>
        {actions ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexShrink: 0, overflow: 'visible' }}>
            {actions}
          </Box>
        ) : null}
      </Toolbar>
    </AppBar>
  );
};

export default Header; 